import { MutableRefObject, useEffect, useState } from 'react'

export function useHasEllipsis({
  parentElRef,
  childElRef,
  offset = 0,
  deps = [],
  fontSize = 'inherit',
  definedMaxWidth = null,
}: {
  parentElRef: MutableRefObject<HTMLElement | null>
  childElRef: MutableRefObject<HTMLElement | null>
  offset?: number
  deps?: any[]
  fontSize?: string
  definedMaxWidth?: number | null
}) {
  const [maxWidth, setMaxWidth] = useState<number>(0)
  const [hasEllipsis, setHasEllipsis] = useState<boolean>(false)

  useEffect(() => {
    if (!parentElRef.current) return

    setMaxWidth(parentElRef.current.clientWidth)
  }, [parentElRef.current, ...deps])

  useEffect(() => {
    if (!childElRef.current) return

    // Create a temporary span to measure text width
    const tempSpan = document.createElement('span')
    tempSpan.style.position = 'absolute'
    tempSpan.style.visibility = 'hidden'
    tempSpan.style.whiteSpace = 'nowrap'
    tempSpan.style.fontSize = fontSize
    tempSpan.style.overflow = 'show'
    tempSpan.textContent = childElRef.current.textContent || ''
    document.body.appendChild(tempSpan)

    const childWidth = tempSpan.offsetWidth
    const maxAllowedWidth = definedMaxWidth || maxWidth - offset

    const isOverflowing = childWidth > maxAllowedWidth

    // Remove the temporary span
    document.body.removeChild(tempSpan)

    setHasEllipsis(isOverflowing)
  }, [childElRef.current, maxWidth, offset, definedMaxWidth, ...deps])

  return hasEllipsis
}
